import { SET_SELECTED_SEARCH_KEY } from "../actions/actionTypes";

export const selectedSearchKey = (state = 'all', action) => {
	switch (action.type) {
		case SET_SELECTED_SEARCH_KEY:
			return action.payload;

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/search.js